import { ReactElement, type JSX } from 'react'
import classNames from 'classnames'
import styles from './IconValuePair.module.scss'

interface IconValuePairProps {
  icon: ReactElement<React.PropsWithChildren>
  value: string
  variant?: string
  isInvalid?: boolean
  testId?: string
}

const IconValuePair = ({
  icon,
  value,
  variant,
  isInvalid,
  testId,
}: Readonly<IconValuePairProps>): JSX.Element => {
  return (
    <div
      data-testid={testId}
      data-invalid={isInvalid === true ? true : undefined}
      className={classNames(styles.wrapper, variant ? styles[variant] : undefined)}
      role="listitem"
    >
      {icon}
      <span className={styles.value}>{value}</span>
    </div>
  )
}

export default IconValuePair
